import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import history from "../../auth/history";
import FileUpload from "./FileUpload";

class ConsumerUploadAndView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			password: '',
			message: ''
		}
	}

	componentDidMount() { }
	componentWillUnmount() {
	}
	render() {
		console.log('Inside render');
		return (
			<div class="col-12 col-lg-4">
				<div class="card">
					<FileUpload />
					<div class="viewcnsmr">
						<Link to='/all-consumer'>
							<button type="button" class="btn blbtn"
							>View Consumers</button>
						</Link>
						<Link to='/add-new-consumer'>
							<button type="button" class="btn blbtn"
							>Add New Consumer</button>
						</Link>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
		miscReduce: { otpRefNo, phone } }
) => ({
	errorMessage, loginErrorMessage, otpErrorMessage, otpRefNo, phone
});

export default connect(mapStateToProps, null)(ConsumerUploadAndView);
